import React from "react";
import {
  StoplossType,
  StoplossTypeName,
  Frequencies,
  FrequencyValues,
  BotType,
  BotTypeName
} from "../../../Const";
import {useSelector } from "react-redux";
import { Row, Table } from "react-bootstrap";

const GridBotSetting = (props) => {
  const { bot,t } = props;
  const theme = useSelector((state) => state.settings.selected_theme);
  const tsls = bot.tsls || [];
  let stoploss = (bot.stop_loss || 0).toFixed(2) + "%";
  if (tsls.length) {
    stoploss =
      tsls[0].sl_type === StoplossType.fixedTsl
        ? StoplossTypeName.fixedTsl
        : StoplossTypeName.variableTsl;
  }
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const gridConfigs = bot.configs;
  const entryIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "entry")
      .map((item) => item.name)
      .join(", ");
  const exitIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "exit")
      .map((item) => item.name)
      .join(", ");
  return (
    <>
    <Row>
      <Table responsive className={`theme-bg ${theme}`}>
        <thead>
          <tr>
            <th>{t("exchange")}</th>
            <th>{t("pair")}</th>
            <th>{t("bot-type")}</th>
            <th>{t("strategy")}</th>
            <th>{t("frequency")}</th>
            <th>{t("no-of-ord")}</th>
            <th>{t("per-order-amount")}</th>
           
            
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                <img
                  src={exchange.image}
                  width={20}
                  height={20}
                  style={{ marginRight: 10 }}
                />
                <span style={{ fontWeight: "bold" }}>{exchange.name}</span>
              </div>
            </td>
            <td>{pair && `${pair.from}/${pair.to}`}</td>
            <td>{bot && BotTypeName[bot.type]}</td>
            <td>{bot && bot.strategy}</td>
            <td>
              {bot && Frequencies[FrequencyValues.indexOf(bot.frequency)]}
            </td>
            <td>{gridConfigs.grid_order_num}</td>
            <td>{gridConfigs.grid_order_vol}</td>
            
            
          </tr>
        </tbody>
      </Table>
    </Row>
    <Row>
      <Table responsive className={`theme-bg ${theme}`}>
        <thead>
          <tr>
            <th>{t("upper-range")}</th>
            <th>{t("lower-range")}</th>
            <th>Exit Wait Time</th>
            <th>Exit Strategy Grids filled</th>
            <th>Exit Strategy No Grids filled</th>
            
          </tr>
        </thead>
        <tbody>
          <tr>
            
            <td>{gridConfigs.grid_upper_range} %</td>
            <td>{gridConfigs.grid_lower_range} %</td>
            <td>{gridConfigs.grid_exit_wait_time} Minutes</td>
            <td>{gridConfigs.grid_exit_strategy_has_trade}</td>
            <td>{gridConfigs.grid_exit_strategy_no_trade}</td>
            
          </tr>
        </tbody>
      </Table>
    </Row>
    </>
  );
};

export default GridBotSetting;
